import React from "react"
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import HowToReg from "@material-ui/icons/HowToReg"
import Lock from "@material-ui/icons/Lock"
import VPNKey from "@material-ui/icons/VpnKey"
// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import InfoArea from "components/InfoArea/InfoArea.jsx"

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx"
import { privaseeBlue } from "assets/jss/material-kit-react.jsx"

class HowItWorksSection extends React.Component {
  render() {
    const { classes } = this.props
    return (
      <div>
        <div className={classes.section}>
          <GridContainer justify="center" style={{ margin: 0 }}>
            <GridItem xs={12} sm={12} md={8}>
              <h2 className={classes.title} style={{ color: "white" }}>
                How It Works
              </h2>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <div
                className={classes.container}
                style={{
                  width: "100%",
                  maxWidth: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: 0,
                  margin: 0,
                }}
              >
                <img
                  src={require("assets/img/website-spa5.png")}
                  style={{
                    width: "75vw",
                    position: "center",
                  }}
                />
                <h3 className={classes.description} style={{ color: "white" }}>
                  1.2.3.4.
                </h3>
                <img
                  src={require("assets/img/website-spa6.png")}
                  style={{
                    width: "75vw",
                    position: "center",
                  }}
                />
              </div>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    )
  }
}

export default withStyles(productStyle)(HowItWorksSection)
